var map = {
	"./BOARD.svg": "ee24",
	"./CARDS.svg": "3dab",
	"./CHARTS.svg": "f79b",
	"./GROUP_BY_TABLE.svg": "1482",
	"./HTML_CONTENT.svg": "23b4",
	"./TABLE.svg": "3a65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b56";